<script setup lang="ts">
import {useCustomizerStore} from '@/stores/customizer';
import {storeToRefs} from "pinia";
import {useAuthentication} from "~/stores/authentication";
import {useApplicationState} from "~/stores/application-state";

const {environment} = useEnvironment()
const {message, available} = storeToRefs(useStatus())

const {actTheme} = storeToRefs(useCustomizerStore());

const {isLoading} = storeToRefs(useApplicationState())
const {showLogin} = storeToRefs(useAuthentication())
</script>

<template>
  <v-app id="console-app"
         :theme="actTheme"
         :class=" [actTheme, 'horizontalLayout' ]">
    <v-app-bar height="30" :color="message.color" flat v-if="message">
      <div class="d-flex w-100 justify-center">
        <div>{{message.message}}</div>
      </div>
    </v-app-bar>
    <v-app-bar height="60" elevation="1">
      <template v-slot:prepend>
        <div class="d-flex align-center gap-4">

          <div class="px-2" style="height: 45px; width: 240px;">
            <NuxtLink to="/">
              <LogoConsole style="width: 250px"></LogoConsole>
            </NuxtLink>
          </div>

          <div v-if="environment">
            <v-chip color="primary">
              {{ environment.featureSet.name }} Edition
            </v-chip>
          </div>
        </div>
      </template>

      <template v-slot:append>
        <NavbarProfile/>
      </template>
    </v-app-bar>

    <AuthLoginScreen v-if="showLogin"/>
    <BootConnectionLoadingScreen v-else-if="isLoading"/>
    <BootOfflineScreen v-else-if="!available"/>

    <template v-else>
      <slot/>
    </template>

    <NotificationSnackbar/>
  </v-app>
</template>
